/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Applicationscope1Inputs */

const en_entity_applicationscope1 = /** @type {(inputs: Entity_Applicationscope1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Scope`)
};

const de_entity_applicationscope1 = /** @type {(inputs: Entity_Applicationscope1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geltungsbereich App`)
};

/**
* | output |
* | --- |
* | "Application Scope" |
*
* @param {Entity_Applicationscope1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_applicationscope1 = /** @type {((inputs?: Entity_Applicationscope1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Applicationscope1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_applicationscope1(inputs)
	return de_entity_applicationscope1(inputs)
});
export { entity_applicationscope1 as "entity_applicationScope" }